export default __webpack_public_path__ + "static/media/logo.ee493c01.png";